import type { ContractReplacement, Milestone } from '../types';

export const canIncludeStageInVariation = (stage: Milestone): boolean =>
  !stage.stageReplacement && !stage.continuedBy &&
  stage.itemType !== 'variation_price_adjustment' &&
  !stage.paidAt &&
  !stage.jointlyAttestedAt &&
  !(
    stage.companyAttestation === 'approved' &&
    stage.personAttestation === 'approved'
  ) &&
  ![
    'paid',
    'jointly_attested',
    'payout_processing',
    'payout_failed',
    'external_dispute'
  ].includes(stage.deliveryStatus ?? '');

export const stageVariationMilestones = (
  settlement: ContractReplacement,
  plan: Milestone[]
): Milestone[] => {
  const selected = new Set(
    settlement.amendmentScope?.milestones.map((stage) => stage.id) ?? []
  );
  return plan.filter(
    (stage) =>
      !stage.replacesMilestoneId || selected.has(stage.replacesMilestoneId)
  );
};

export const stageVariationOre = (value: string): number => {
  if (!value.trim()) return NaN;
  return Math.round(Number(value.replace(/\s/g, '').replace(',', '.')) * 100);
};

/** Signed ROT follows the direction of the amount, including credits in ÄTA. */
export const validStageVariationAmounts = (gross: number, net: number): boolean =>
  Number.isSafeInteger(gross) && Number.isSafeInteger(net) &&
  (net === 0 || Math.sign(gross) === Math.sign(net)) &&
  Math.abs(gross) >= Math.abs(net);
